import { render, staticRenderFns } from "./questionCard.vue?vue&type=template&id=3b644d21"
import script from "./questionCard.vue?vue&type=script&lang=js"
export * from "./questionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports